import ActionTypes from '../constants/ActionTypes';
import decode from 'jwt-decode';
import { State } from '../reducers';
import User from '../interfaces/user';

let profiles = {};
const hasDevOverride = false;
const devOverride = 'loggedin-no-fb';

if (process.env.NODE_ENV === 'development') {
  profiles = {
    'loggedin-no-fb': {
      data: {
        id: 10186103,
        loggedIn: true,
        connectedToFacebook: false,
        isNewUser: false,
        supportThreadId: 502181,
        supportUnreadCount: 20,
        supportMessageId: 32341027,
        postcode: 2136,
        suburb: 'Strathfield South',
        suburb_id: 518,
        facebookUrl:
          'https://www.facebook.com/v2.10/dialog/oauth?client_id=102132386588242&redirect_uri=https%3A%2F%2Fhapi.hipages.com.au%2Ffacebook%2Fauth&state=26e72adf4a4d1806f19bc0f56b5a4dff%3A7942f&sdk=php-sdk-4.0.23&scope=public_profile%2Cemail%2Cuser_friends&display=popup',
        email: 'lishengpayment5@mailinator.com',
        isPasswordSet: 1,
        firstName: 'Lisheng',
        surname: 'Payment',
        accountId: 345932,
      },
      token:
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoxNzc2MzE0NSwiaWF0IjoxNTQ0NDEzODk0LCJleHAiOjE1NDQ0MTU2OTR9.5FtmFIuGSKe0nbe1Eh_5KINVHSI0pv-mJo232aUDVoM',
    },
    'loggedin-fb': {
      data: {
        id: 17199557,
        loggedIn: true,
        connectedToFacebook: true,
        isNewUser: false,
        supportThreadId: 4773273,
        supportUnreadCount: 20,
        postcode: 2136,
        suburb: 'Strathfield South',
        suburb_id: 518,
        supportMessageId: 31101445,
        facebookUrl:
          'https://www.facebook.com/v2.10/dialog/oauth?client_id=102132386588242&redirect_uri=https%3A%2F%2Fhapi.hipages.com.au%2Ffacebook%2Fauth&state=26e72adf4a4d1806f19bc0f56b5a4dff%3A7942f&sdk=php-sdk-4.0.23&scope=public_profile%2Cemail%2Cuser_friends&display=popup',
        email: 'lishengpayment5@mailinator.com',
        isPasswordSet: 1,
        firstName: 'Micheal',
        surname: 'Delaney',
        accountId: 428832,
      },
      token:
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoxNzE5OTU1NywiaWF0IjoxNTQ0NDE0NDcxLCJleHAiOjE1NDQ0MTYyNzEwMH0.KX6sRoC_NYjUGIdzPnjfNNtNnR_a04JcDWf9WmW67lk',
    },
  };
}

export interface UserInfo {
  loggedIn: boolean;
  name?: string;
  email?: string;
  phone?: string;
}

export function getUserInfoForGQ(state): UserInfo {
  const { user } = state;
  if (!user.data || !user.data.logged_in) {
    return {
      loggedIn: false,
    };
  }
  const { username, email, phone } = user.data;
  return {
    loggedIn: true,
    name: username,
    email,
    phone,
  };
}

export function getUserLoginState(state: State): User {
  const { user } = state;
  if (process.env.NODE_ENV === 'development' && hasDevOverride) {
    return profiles[devOverride] && profiles[devOverride].data;
  }
  if (!user.data)
    return {
      id: -1,
      loggedIn: false,
      connectedToFacebook: false,
      isNewUser: false,
      supportThreadId: 0,
      supportUnreadCount: 0,
      supportMessageId: 0,
      facebookUrl: null,
      email: null,
      isPasswordSet: false,
      firstName: null,
      surname: null,
      accountId: null,
      suburb: null,
      postcode: null,
    };
  return {
    id: user.data.user_id,
    loggedIn: user.data.logged_in,
    connectedToFacebook: user.data.fb_connected,
    isNewUser: user.data.is_new_user,
    facebookUrl: user.data.facebook_login_url,
    email: user.data.email,
    suburb: user.data.suburb,
    postcode: user.data.postcode,
    supportThreadId: user.data.support_thread_id,
    supportUnreadCount: user.data.support_unread_count,
    supportMessageId: user.data.support_message_id,
    isPasswordSet: user.data.is_password_set,
    firstName: user.data.first_name,
    surname: user.data.surname,
    accountId: user.data.account_id,
  };
}

const decodeToken = token => {
  try {
    return decode(token);
  } catch (e) {
    return null;
  }
};

export function hasToken(state) {
  const { user } = state;
  if (process.env.NODE_ENV === 'development' && hasDevOverride) {
    return true;
  }
  if (user.token.value) {
    const token = user.token.value;
    const decoded = decodeToken(token);
    if (!decoded) return false;
    return decoded.exp > Math.floor(Date.now() / 1000);
  }
  return false;
}

export function getToken(state) {
  const { user } = state;
  if (process.env.NODE_ENV === 'development' && hasDevOverride) {
    return profiles[devOverride] && profiles[devOverride].token;
  }
  if (!hasToken(state)) {
    return;
  }
  return user.token.value;
}

export function hasAttemptedLogin(state) {
  const { user } = state;
  if (process.env.NODE_ENV === 'development' && hasDevOverride) {
    return true;
  }
  return user.status !== ActionTypes.USER_LOGIN_CHECK_UNKNOWN;
}

export function getFacebookLoginUrl(state) {
  const { user } = state;
  return user.data && user.data.facebook_login_url;
}

export function getPasswordState(state) {
  const { user } = state;
  return user.passwordStatus;
}

export function getConnectFacebookState(state) {
  const { user } = state;
  return user.connectFacebookStatus;
}
